var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"loadNodeTree",staticClass:"list-tree",attrs:{"node-key":"id","load":_vm.loadNode,"props":_vm.treeProps,"lazy":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }